import http from 'axios'
import config from '@/config'
import lib from '@/library'

export default {
  get,
  psheadline,
  cduevents,
  cduscreenconfiguration,
  oracleecho
}

function cduevents (paramsMap) {
  return get('cduevents', [
    'language',
    'region',
    'maxnumofmarketsperevent',
    'screenid',
    'flags'
  ], paramsMap)
}

function psheadline (paramsMap) {
  return get('psheadline', [
    'region',
    'language'
  ], paramsMap)
}

function cduscreenconfiguration (paramsMap) {
  return get('cduscreenconfiguration', [
    'screenid'
  ], paramsMap)
}

function oracleecho (paramsMap) {
  return get('oracleecho', [
    'dummy'
  ], paramsMap)
}

function get (generator, paramsList, paramsMap) {
  paramsMap = paramsMap || {}

  if (Array.isArray(paramsList)) {
    if (paramsMap) {
      replaceInArray(paramsList, paramsMap)
    }

    return http.get(createGeneratorUrl(generator, paramsList))
  }
}

function createGeneratorUrl (generator, params) {
  return lib.core.url.joinSegments([
    config.app.contentServerHostname,
    'cache',
    generator
  ].concat(params)).concat('.' + config.kansas.responseType)
}

function replaceInArray (array, map) {
  map.idmmbusinessunit = config.app.businessUnit
  map.region = config.app.region

  if (!map.language) {
    map.language = config.app.language
  }

  for (var i = 0; i < array.length; i++) {
    for (var variable in map) {
      if (map.hasOwnProperty(variable)) {
        if (array[i] === variable) {
          array[i] = map[variable]
          break
        }
      }
    }
  }
  return array
}



// WEBPACK FOOTER //
// ./src/library/kansas/index.js